import { GraphQlClient } from '@intelipost-js/secure-providers';

export default {
  getInvoiceDetail({ commit }, params) {
    commit('recon/preInvoiceDetail/toggleLoading', true, { root: true });

    return GraphQlClient.query(`
    query ($id: String!, $action: String!) {
      preInvoiceDetail(id: $id, action: $action) {
        values {
          order_number
          products_value
          total_value
          origin_zipcode
          destination_zipcode
          invoice {
            number
            serie
            key
            content_declaration
            value
          }
          cte {
            number
            serie
            key
            company_name
            freight_value
          }
          volumes {
            id
            tracking_code
            weight
            squared_weight
            selected_weight
            dimensions {
              width
              height
              length
            }
          }
          taxes {
            name
            type
            formula
            values {
              tms {
                value
                percent
              }
              cte {
                value
                percent
              }
            }
          }
        }
      }
    }
    `, params)
    .then(({ data }) => {
      const { preInvoiceDetail = {} } = data || {};
      const { values: invoiceDetailValues } = preInvoiceDetail || {};

      commit('setInvoiceValues', invoiceDetailValues || {});
      commit('recon/preInvoiceDetail/toggleLoading', false, { root: true });
    })
    .catch(() =>
      commit('recon/preInvoiceDetail/toggleLoading', false, { root: true }),
    );
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/pre-invoice-detail/components/sc-pre-invoice-detail-values/store/actions.js